import React, { Component } from "react"
import messagesSvg from "./../images/messages-svg.svg";

class LandingFaq extends Component {

  render() {
    const layout = this.props.content
    return (
      <div className="container">
        <div className="uk-child-width-1-2@m uk-flex columns-wrp" data-uk-grid>
          {layout.relationships.field_question && layout.relationships.field_question.map( (item,key) =>(
            <div className="uk-flex uk-flex-row" key={`landing-faq-${key}`}>
              <div className="section-311-two-columns-icon-wrp">
                {item.relationships.field_icon ? (
                  <img src={item.relationships.field_icon?.uri?.url} alt={item.relationships.field_icon?.filename} />
                ) : (
                  null
                )}
              </div>
              <div>
                <h2 className="section-311-title">{item.field_title}</h2>
                <p>{item.field_description}</p>
                {item.field_link ? (
                  <div className="section-311-two-columns-icons-link">
                    <a href={item.field_link?.uri.replace("internal:","")}>{item.field_link?.title}</a>
                  </div>
                ) : (
                  null
                )}
              </div>
            </div>
          ))}

        </div>
      </div>
    )
  }
}

export default LandingFaq
